// List of currency codes obtained from
// https://www.currency-iso.org/en/home/tables/table-a1.html
//
// parsed using this snipped
// https://git.sqcorp.co/snippets/6f46becb4bec4395bc586c52f9a6b44a

interface CurrencyCodeInfoEntry {
  name: string;
  code: string;
  number: string;
  minorUnit: number;
}

interface CurrencyCodeInfo {
  [key: string]: CurrencyCodeInfoEntry;
}

const CURRENCY_CODE_INFO: CurrencyCodeInfo = {
  AFN: {
    name: 'Afghani',
    code: 'AFN',
    number: '971',
    minorUnit: 2,
  },
  ALL: {
    name: 'Lek',
    code: 'ALL',
    number: '008',
    minorUnit: 2,
  },
  AMD: {
    name: 'Armenian Dram',
    code: 'AMD',
    number: '051',
    minorUnit: 2,
  },
  ANG: {
    name: 'Netherlands Antillean Guilder',
    code: 'ANG',
    number: '532',
    minorUnit: 2,
  },
  AOA: {
    name: 'Kwanza',
    code: 'AOA',
    number: '973',
    minorUnit: 2,
  },
  ARS: {
    name: 'Argentine Peso',
    code: 'ARS',
    number: '032',
    minorUnit: 2,
  },
  AUD: {
    name: 'Australian Dollar',
    code: 'AUD',
    number: '036',
    minorUnit: 2,
  },
  AWG: {
    name: 'Aruban Florin',
    code: 'AWG',
    number: '533',
    minorUnit: 2,
  },
  AZN: {
    name: 'Azerbaijan Manat',
    code: 'AZN',
    number: '944',
    minorUnit: 2,
  },
  BAM: {
    name: 'Convertible Mark',
    code: 'BAM',
    number: '977',
    minorUnit: 2,
  },
  BBD: {
    name: 'Barbados Dollar',
    code: 'BBD',
    number: '052',
    minorUnit: 2,
  },
  BDT: {
    name: 'Taka',
    code: 'BDT',
    number: '050',
    minorUnit: 2,
  },
  BGN: {
    name: 'Bulgarian Lev',
    code: 'BGN',
    number: '975',
    minorUnit: 2,
  },
  BHD: {
    name: 'Bahraini Dinar',
    code: 'BHD',
    number: '048',
    minorUnit: 3,
  },
  BIF: {
    name: 'Burundi Franc',
    code: 'BIF',
    number: '108',
    minorUnit: 0,
  },
  BMD: {
    name: 'Bermudian Dollar',
    code: 'BMD',
    number: '060',
    minorUnit: 2,
  },
  BND: {
    name: 'Brunei Dollar',
    code: 'BND',
    number: '096',
    minorUnit: 2,
  },
  BOB: {
    name: 'Boliviano',
    code: 'BOB',
    number: '068',
    minorUnit: 2,
  },
  BOV: {
    name: 'Mvdol',
    code: 'BOV',
    number: '984',
    minorUnit: 2,
  },
  BRL: {
    name: 'Brazilian Real',
    code: 'BRL',
    number: '986',
    minorUnit: 2,
  },
  BSD: {
    name: 'Bahamian Dollar',
    code: 'BSD',
    number: '044',
    minorUnit: 2,
  },
  BTN: {
    name: 'Ngultrum',
    code: 'BTN',
    number: '064',
    minorUnit: 2,
  },
  BWP: {
    name: 'Pula',
    code: 'BWP',
    number: '072',
    minorUnit: 2,
  },
  BYN: {
    name: 'Belarusian Ruble',
    code: 'BYN',
    number: '933',
    minorUnit: 2,
  },
  BZD: {
    name: 'Belize Dollar',
    code: 'BZD',
    number: '084',
    minorUnit: 2,
  },
  CAD: {
    name: 'Canadian Dollar',
    code: 'CAD',
    number: '124',
    minorUnit: 2,
  },
  CDF: {
    name: 'Congolese Franc',
    code: 'CDF',
    number: '976',
    minorUnit: 2,
  },
  CHE: {
    name: 'WIR Euro',
    code: 'CHE',
    number: '947',
    minorUnit: 2,
  },
  CHF: {
    name: 'Swiss Franc',
    code: 'CHF',
    number: '756',
    minorUnit: 2,
  },
  CHW: {
    name: 'WIR Franc',
    code: 'CHW',
    number: '948',
    minorUnit: 2,
  },
  CLF: {
    name: 'Unidad de Fomento',
    code: 'CLF',
    number: '990',
    minorUnit: 4,
  },
  CLP: {
    name: 'Chilean Peso',
    code: 'CLP',
    number: '152',
    minorUnit: 0,
  },
  CNY: {
    name: 'Yuan Renminbi',
    code: 'CNY',
    number: '156',
    minorUnit: 2,
  },
  COP: {
    name: 'Colombian Peso',
    code: 'COP',
    number: '170',
    minorUnit: 2,
  },
  COU: {
    name: 'Unidad de Valor Real',
    code: 'COU',
    number: '970',
    minorUnit: 2,
  },
  CRC: {
    name: 'Costa Rican Colon',
    code: 'CRC',
    number: '188',
    minorUnit: 2,
  },
  CUC: {
    name: 'Peso Convertible',
    code: 'CUC',
    number: '931',
    minorUnit: 2,
  },
  CUP: {
    name: 'Cuban Peso',
    code: 'CUP',
    number: '192',
    minorUnit: 2,
  },
  CVE: {
    name: 'Cabo Verde Escudo',
    code: 'CVE',
    number: '132',
    minorUnit: 2,
  },
  CZK: {
    name: 'Czech Koruna',
    code: 'CZK',
    number: '203',
    minorUnit: 2,
  },
  DJF: {
    name: 'Djibouti Franc',
    code: 'DJF',
    number: '262',
    minorUnit: 0,
  },
  DKK: {
    name: 'Danish Krone',
    code: 'DKK',
    number: '208',
    minorUnit: 2,
  },
  DOP: {
    name: 'Dominican Peso',
    code: 'DOP',
    number: '214',
    minorUnit: 2,
  },
  DZD: {
    name: 'Algerian Dinar',
    code: 'DZD',
    number: '012',
    minorUnit: 2,
  },
  EGP: {
    name: 'Egyptian Pound',
    code: 'EGP',
    number: '818',
    minorUnit: 2,
  },
  ERN: {
    name: 'Nakfa',
    code: 'ERN',
    number: '232',
    minorUnit: 2,
  },
  ETB: {
    name: 'Ethiopian Birr',
    code: 'ETB',
    number: '230',
    minorUnit: 2,
  },
  EUR: {
    name: 'Euro',
    code: 'EUR',
    number: '978',
    minorUnit: 2,
  },
  FJD: {
    name: 'Fiji Dollar',
    code: 'FJD',
    number: '242',
    minorUnit: 2,
  },
  FKP: {
    name: 'Falkland Islands Pound',
    code: 'FKP',
    number: '238',
    minorUnit: 2,
  },
  GBP: {
    name: 'Pound Sterling',
    code: 'GBP',
    number: '826',
    minorUnit: 2,
  },
  GEL: {
    name: 'Lari',
    code: 'GEL',
    number: '981',
    minorUnit: 2,
  },
  GHS: {
    name: 'Ghana Cedi',
    code: 'GHS',
    number: '936',
    minorUnit: 2,
  },
  GIP: {
    name: 'Gibraltar Pound',
    code: 'GIP',
    number: '292',
    minorUnit: 2,
  },
  GMD: {
    name: 'Dalasi',
    code: 'GMD',
    number: '270',
    minorUnit: 2,
  },
  GNF: {
    name: 'Guinean Franc',
    code: 'GNF',
    number: '324',
    minorUnit: 0,
  },
  GTQ: {
    name: 'Quetzal',
    code: 'GTQ',
    number: '320',
    minorUnit: 2,
  },
  GYD: {
    name: 'Guyana Dollar',
    code: 'GYD',
    number: '328',
    minorUnit: 2,
  },
  HKD: {
    name: 'Hong Kong Dollar',
    code: 'HKD',
    number: '344',
    minorUnit: 2,
  },
  HNL: {
    name: 'Lempira',
    code: 'HNL',
    number: '340',
    minorUnit: 2,
  },
  HRK: {
    name: 'Kuna',
    code: 'HRK',
    number: '191',
    minorUnit: 2,
  },
  HTG: {
    name: 'Gourde',
    code: 'HTG',
    number: '332',
    minorUnit: 2,
  },
  HUF: {
    name: 'Forint',
    code: 'HUF',
    number: '348',
    minorUnit: 2,
  },
  IDR: {
    name: 'Rupiah',
    code: 'IDR',
    number: '360',
    minorUnit: 2,
  },
  ILS: {
    name: 'New Israeli Sheqel',
    code: 'ILS',
    number: '376',
    minorUnit: 2,
  },
  INR: {
    name: 'Indian Rupee',
    code: 'INR',
    number: '356',
    minorUnit: 2,
  },
  IQD: {
    name: 'Iraqi Dinar',
    code: 'IQD',
    number: '368',
    minorUnit: 3,
  },
  IRR: {
    name: 'Iranian Rial',
    code: 'IRR',
    number: '364',
    minorUnit: 2,
  },
  ISK: {
    name: 'Iceland Krona',
    code: 'ISK',
    number: '352',
    minorUnit: 0,
  },
  JMD: {
    name: 'Jamaican Dollar',
    code: 'JMD',
    number: '388',
    minorUnit: 2,
  },
  JOD: {
    name: 'Jordanian Dinar',
    code: 'JOD',
    number: '400',
    minorUnit: 3,
  },
  JPY: {
    name: 'Yen',
    code: 'JPY',
    number: '392',
    minorUnit: 0,
  },
  KES: {
    name: 'Kenyan Shilling',
    code: 'KES',
    number: '404',
    minorUnit: 2,
  },
  KGS: {
    name: 'Som',
    code: 'KGS',
    number: '417',
    minorUnit: 2,
  },
  KHR: {
    name: 'Riel',
    code: 'KHR',
    number: '116',
    minorUnit: 2,
  },
  KMF: {
    name: 'Comorian Franc ',
    code: 'KMF',
    number: '174',
    minorUnit: 0,
  },
  KPW: {
    name: 'North Korean Won',
    code: 'KPW',
    number: '408',
    minorUnit: 2,
  },
  KRW: {
    name: 'Won',
    code: 'KRW',
    number: '410',
    minorUnit: 0,
  },
  KWD: {
    name: 'Kuwaiti Dinar',
    code: 'KWD',
    number: '414',
    minorUnit: 3,
  },
  KYD: {
    name: 'Cayman Islands Dollar',
    code: 'KYD',
    number: '136',
    minorUnit: 2,
  },
  KZT: {
    name: 'Tenge',
    code: 'KZT',
    number: '398',
    minorUnit: 2,
  },
  LAK: {
    name: 'Lao Kip',
    code: 'LAK',
    number: '418',
    minorUnit: 2,
  },
  LBP: {
    name: 'Lebanese Pound',
    code: 'LBP',
    number: '422',
    minorUnit: 2,
  },
  LKR: {
    name: 'Sri Lanka Rupee',
    code: 'LKR',
    number: '144',
    minorUnit: 2,
  },
  LRD: {
    name: 'Liberian Dollar',
    code: 'LRD',
    number: '430',
    minorUnit: 2,
  },
  LSL: {
    name: 'Loti',
    code: 'LSL',
    number: '426',
    minorUnit: 2,
  },
  LYD: {
    name: 'Libyan Dinar',
    code: 'LYD',
    number: '434',
    minorUnit: 3,
  },
  MAD: {
    name: 'Moroccan Dirham',
    code: 'MAD',
    number: '504',
    minorUnit: 2,
  },
  MDL: {
    name: 'Moldovan Leu',
    code: 'MDL',
    number: '498',
    minorUnit: 2,
  },
  MGA: {
    name: 'Malagasy Ariary',
    code: 'MGA',
    number: '969',
    minorUnit: 2,
  },
  MKD: {
    name: 'Denar',
    code: 'MKD',
    number: '807',
    minorUnit: 2,
  },
  MMK: {
    name: 'Kyat',
    code: 'MMK',
    number: '104',
    minorUnit: 2,
  },
  MNT: {
    name: 'Tugrik',
    code: 'MNT',
    number: '496',
    minorUnit: 2,
  },
  MOP: {
    name: 'Pataca',
    code: 'MOP',
    number: '446',
    minorUnit: 2,
  },
  MRU: {
    name: 'Ouguiya',
    code: 'MRU',
    number: '929',
    minorUnit: 2,
  },
  MUR: {
    name: 'Mauritius Rupee',
    code: 'MUR',
    number: '480',
    minorUnit: 2,
  },
  MVR: {
    name: 'Rufiyaa',
    code: 'MVR',
    number: '462',
    minorUnit: 2,
  },
  MWK: {
    name: 'Malawi Kwacha',
    code: 'MWK',
    number: '454',
    minorUnit: 2,
  },
  MXN: {
    name: 'Mexican Peso',
    code: 'MXN',
    number: '484',
    minorUnit: 2,
  },
  MXV: {
    name: 'Mexican Unidad de Inversion (UDI)',
    code: 'MXV',
    number: '979',
    minorUnit: 2,
  },
  MYR: {
    name: 'Malaysian Ringgit',
    code: 'MYR',
    number: '458',
    minorUnit: 2,
  },
  MZN: {
    name: 'Mozambique Metical',
    code: 'MZN',
    number: '943',
    minorUnit: 2,
  },
  NAD: {
    name: 'Namibia Dollar',
    code: 'NAD',
    number: '516',
    minorUnit: 2,
  },
  NGN: {
    name: 'Naira',
    code: 'NGN',
    number: '566',
    minorUnit: 2,
  },
  NIO: {
    name: 'Cordoba Oro',
    code: 'NIO',
    number: '558',
    minorUnit: 2,
  },
  NOK: {
    name: 'Norwegian Krone',
    code: 'NOK',
    number: '578',
    minorUnit: 2,
  },
  NPR: {
    name: 'Nepalese Rupee',
    code: 'NPR',
    number: '524',
    minorUnit: 2,
  },
  NZD: {
    name: 'New Zealand Dollar',
    code: 'NZD',
    number: '554',
    minorUnit: 2,
  },
  OMR: {
    name: 'Rial Omani',
    code: 'OMR',
    number: '512',
    minorUnit: 3,
  },
  PAB: {
    name: 'Balboa',
    code: 'PAB',
    number: '590',
    minorUnit: 2,
  },
  PEN: {
    name: 'Sol',
    code: 'PEN',
    number: '604',
    minorUnit: 2,
  },
  PGK: {
    name: 'Kina',
    code: 'PGK',
    number: '598',
    minorUnit: 2,
  },
  PHP: {
    name: 'Philippine Piso',
    code: 'PHP',
    number: '608',
    minorUnit: 2,
  },
  PKR: {
    name: 'Pakistan Rupee',
    code: 'PKR',
    number: '586',
    minorUnit: 2,
  },
  PLN: {
    name: 'Zloty',
    code: 'PLN',
    number: '985',
    minorUnit: 2,
  },
  PYG: {
    name: 'Guarani',
    code: 'PYG',
    number: '600',
    minorUnit: 0,
  },
  QAR: {
    name: 'Qatari Rial',
    code: 'QAR',
    number: '634',
    minorUnit: 2,
  },
  RON: {
    name: 'Romanian Leu',
    code: 'RON',
    number: '946',
    minorUnit: 2,
  },
  RSD: {
    name: 'Serbian Dinar',
    code: 'RSD',
    number: '941',
    minorUnit: 2,
  },
  RUB: {
    name: 'Russian Ruble',
    code: 'RUB',
    number: '643',
    minorUnit: 2,
  },
  RWF: {
    name: 'Rwanda Franc',
    code: 'RWF',
    number: '646',
    minorUnit: 0,
  },
  SAR: {
    name: 'Saudi Riyal',
    code: 'SAR',
    number: '682',
    minorUnit: 2,
  },
  SBD: {
    name: 'Solomon Islands Dollar',
    code: 'SBD',
    number: '090',
    minorUnit: 2,
  },
  SCR: {
    name: 'Seychelles Rupee',
    code: 'SCR',
    number: '690',
    minorUnit: 2,
  },
  SDG: {
    name: 'Sudanese Pound',
    code: 'SDG',
    number: '938',
    minorUnit: 2,
  },
  SEK: {
    name: 'Swedish Krona',
    code: 'SEK',
    number: '752',
    minorUnit: 2,
  },
  SGD: {
    name: 'Singapore Dollar',
    code: 'SGD',
    number: '702',
    minorUnit: 2,
  },
  SHP: {
    name: 'Saint Helena Pound',
    code: 'SHP',
    number: '654',
    minorUnit: 2,
  },
  SLL: {
    name: 'Leone',
    code: 'SLL',
    number: '694',
    minorUnit: 2,
  },
  SOS: {
    name: 'Somali Shilling',
    code: 'SOS',
    number: '706',
    minorUnit: 2,
  },
  SRD: {
    name: 'Surinam Dollar',
    code: 'SRD',
    number: '968',
    minorUnit: 2,
  },
  SSP: {
    name: 'South Sudanese Pound',
    code: 'SSP',
    number: '728',
    minorUnit: 2,
  },
  STN: {
    name: 'Dobra',
    code: 'STN',
    number: '930',
    minorUnit: 2,
  },
  SVC: {
    name: 'El Salvador Colon',
    code: 'SVC',
    number: '222',
    minorUnit: 2,
  },
  SYP: {
    name: 'Syrian Pound',
    code: 'SYP',
    number: '760',
    minorUnit: 2,
  },
  SZL: {
    name: 'Lilangeni',
    code: 'SZL',
    number: '748',
    minorUnit: 2,
  },
  THB: {
    name: 'Baht',
    code: 'THB',
    number: '764',
    minorUnit: 2,
  },
  TJS: {
    name: 'Somoni',
    code: 'TJS',
    number: '972',
    minorUnit: 2,
  },
  TMT: {
    name: 'Turkmenistan New Manat',
    code: 'TMT',
    number: '934',
    minorUnit: 2,
  },
  TND: {
    name: 'Tunisian Dinar',
    code: 'TND',
    number: '788',
    minorUnit: 3,
  },
  TOP: {
    name: 'Pa’anga',
    code: 'TOP',
    number: '776',
    minorUnit: 2,
  },
  TRY: {
    name: 'Turkish Lira',
    code: 'TRY',
    number: '949',
    minorUnit: 2,
  },
  TTD: {
    name: 'Trinidad and Tobago Dollar',
    code: 'TTD',
    number: '780',
    minorUnit: 2,
  },
  TWD: {
    name: 'New Taiwan Dollar',
    code: 'TWD',
    number: '901',
    minorUnit: 2,
  },
  TZS: {
    name: 'Tanzanian Shilling',
    code: 'TZS',
    number: '834',
    minorUnit: 2,
  },
  UAH: {
    name: 'Hryvnia',
    code: 'UAH',
    number: '980',
    minorUnit: 2,
  },
  UGX: {
    name: 'Uganda Shilling',
    code: 'UGX',
    number: '800',
    minorUnit: 0,
  },
  USD: {
    name: 'US Dollar',
    code: 'USD',
    number: '840',
    minorUnit: 2,
  },
  USN: {
    name: 'US Dollar (Next day)',
    code: 'USN',
    number: '997',
    minorUnit: 2,
  },
  UYI: {
    name: 'Uruguay Peso en Unidades Indexadas (URUIURUI)',
    code: 'UYI',
    number: '940',
    minorUnit: 0,
  },
  UYU: {
    name: 'Peso Uruguayo',
    code: 'UYU',
    number: '858',
    minorUnit: 2,
  },
  UZS: {
    name: 'Uzbekistan Sum',
    code: 'UZS',
    number: '860',
    minorUnit: 2,
  },
  VEF: {
    name: 'Bolívar',
    code: 'VEF',
    number: '937',
    minorUnit: 2,
  },
  VND: {
    name: 'Dong',
    code: 'VND',
    number: '704',
    minorUnit: 0,
  },
  VUV: {
    name: 'Vatu',
    code: 'VUV',
    number: '548',
    minorUnit: 0,
  },
  WST: {
    name: 'Tala',
    code: 'WST',
    number: '882',
    minorUnit: 2,
  },
  XAF: {
    name: 'CFA Franc BEAC',
    code: 'XAF',
    number: '950',
    minorUnit: 0,
  },
  XCD: {
    name: 'East Caribbean Dollar',
    code: 'XCD',
    number: '951',
    minorUnit: 2,
  },
  XOF: {
    name: 'CFA Franc BCEAO',
    code: 'XOF',
    number: '952',
    minorUnit: 0,
  },
  XPF: {
    name: 'CFP Franc',
    code: 'XPF',
    number: '953',
    minorUnit: 0,
  },
  XXX: {
    name: 'No Currency',
    code: 'XXX',
    number: '999',
    minorUnit: 0,
  },
  YER: {
    name: 'Yemeni Rial',
    code: 'YER',
    number: '886',
    minorUnit: 2,
  },
  ZAR: {
    name: 'Rand',
    code: 'ZAR',
    number: '710',
    minorUnit: 2,
  },
  ZMW: {
    name: 'Zambian Kwacha',
    code: 'ZMW',
    number: '967',
    minorUnit: 2,
  },
  ZWL: {
    name: 'Zimbabwe Dollar',
    code: 'ZWL',
    number: '932',
    minorUnit: 2,
  },
};

export default CURRENCY_CODE_INFO;
